"use client";

import { useSyncExternalStore } from "react";

const subscribe = () => () => undefined;

export default function TrainingAccessBanner() {
  const configuredOrigin = process.env.NEXT_PUBLIC_VINTERA_LOCAL_TRAINING_ORIGIN;
  const enabled = process.env.NEXT_PUBLIC_VINTERA_ALLOW_TRAINING_FUNNEL === "true"
    && process.env.NEXT_PUBLIC_VINTERA_DEPLOYMENT_ENV === "local"
    && Boolean(configuredOrigin);
  const visible = useSyncExternalStore(
    subscribe,
    () => enabled && window.location.origin === configuredOrigin,
    () => false,
  );

  if (!visible) return null;
  return (
    <div className="border-b border-amber-300 bg-amber-50 px-4 py-2 text-center text-xs font-bold uppercase tracking-wide text-amber-950">
      Temporary Vintera Partner Testing
    </div>
  );
}
